var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "visitor-history" } },
    [
      _c(
        "div",
        { attrs: { id: "visitor-history-filter-row" } },
        [
          _c("datetime", {
            attrs: {
              "max-datetime": _vm.maxDate,
              "min-datetime": _vm.lastFiveYear,
              phrases: _vm.phrases,
              placeholder: _vm.$t("message.startDate"),
              locale: _vm.$i18n.locale,
              auto: "",
              "input-class": "form-control rounded-0",
              "input-id": "start-date-input",
              type: "datetime",
            },
            on: { input: _vm.onStartDateChange },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _vm._v(" "),
          _c("datetime", {
            attrs: {
              "max-datetime": _vm.maxDate,
              "min-datetime": _vm.getMinEndDate,
              phrases: _vm.phrases,
              placeholder: _vm.$t("message.endDate"),
              locale: _vm.$i18n.locale,
              auto: "",
              "input-class": "form-control rounded-0",
              "input-id": "end-date-input",
              type: "datetime",
            },
            on: { input: _vm.onEndDateChange },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.getChannelOptions(),
              "label-key": "label",
              "id-key": "id",
              title: _vm.$t("message.selectChannel"),
              icon: "hub",
            },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.selectedChannel,
              callback: function ($$v) {
                _vm.selectedChannel = $$v
              },
              expression: "selectedChannel",
            },
          }),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.getDepartmentOptions(),
              "label-key": "label",
              "id-key": "id",
              title: _vm.$t("message.allDepartments"),
              icon: "business",
            },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.selectedDepartment,
              callback: function ($$v) {
                _vm.selectedDepartment = $$v
              },
              expression: "selectedDepartment",
            },
          }),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.getStartOptions(),
              "label-key": "label",
              "id-key": "id",
              title: _vm.$t("message.choosePoints"),
              icon: "star",
            },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.point,
              callback: function ($$v) {
                _vm.point = $$v
              },
              expression: "point",
            },
          }),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.getAgentsOptions(),
              "label-key": "label",
              "id-key": "id",
              title: _vm.$t("message.selectRepresentativeChatbot"),
              icon: "support_agent",
            },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.selectedUser,
              callback: function ($$v) {
                _vm.selectedUser = $$v
              },
              expression: "selectedUser",
            },
          }),
          _vm._v(" "),
          _c("CustomPicker", {
            attrs: {
              items: _vm.getDomainOptions(),
              "label-key": "label",
              "id-key": "id",
              title: _vm.$t("message.selectDomain"),
              icon: "travel_explore",
            },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.selectedCustomerDomains,
              callback: function ($$v) {
                _vm.selectedCustomerDomains = $$v
              },
              expression: "selectedCustomerDomains",
            },
          }),
          _vm._v(" "),
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.search") },
            on: { change: _vm.saveFilters },
            model: {
              value: _vm.query,
              callback: function ($$v) {
                _vm.query = $$v
              },
              expression: "query",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("supsis-table", {
        attrs: {
          columns: _vm.columns,
          rows: _vm.visitorData,
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
          bottomAlign: "space-between",
          headAlign: "right",
          downloadOptions: {
            downloadAll: true,
            downloadTable: true,
          },
          tableSettings: true,
        },
        on: {
          "cursor-changed": function (cursor) {
            _vm.paginationCursor = cursor
            _vm.savePageSize(cursor.perPage)
          },
          "download-table": _vm.exportToExcel,
          "download-all": _vm.downloadAsFile,
          "table-settings": _vm.openVisitorHistorySettingsModal,
        },
      }),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.$t("message.excelDownload"),
            footer: null,
            width: 400,
          },
          on: { cancel: _vm.cancelDownloadModal },
          model: {
            value: _vm.showDownloadModal,
            callback: function ($$v) {
              _vm.showDownloadModal = $$v
            },
            expression: "showDownloadModal",
          },
        },
        [
          _c("div", { staticClass: "excel-download-modal" }, [
            _c("div", { staticClass: "download-options" }, [
              _c("div", { staticClass: "option-title" }, [
                _vm._v(_vm._s(_vm.$t("message.excelExportReceiveQuestion"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("self")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "option-radio" },
                    [
                      _c("a-radio", {
                        attrs: { checked: _vm.selectedOption === "self" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-content" }, [
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.sendToMe"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.user && _vm.user.email ? _vm.user.email : "-"
                        )
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectOption("other")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "option-radio" },
                    [
                      _c("a-radio", {
                        attrs: { checked: _vm.selectedOption === "other" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-content" }, [
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v(_vm._s(_vm.$t("message.sendToSomeoneElse"))),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.selectedOption === "other"
                ? _c(
                    "div",
                    { staticClass: "email-input-area" },
                    [
                      _c("a-input", {
                        staticClass: "custom-email-input",
                        attrs: {
                          placeholder: _vm.$t("message.enterEmailAddress"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prefix",
                              fn: function () {
                                return [
                                  _c("a-icon", {
                                    staticStyle: { color: "rgba(0,0,0,.25)" },
                                    attrs: { type: "mail" },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1015637592
                        ),
                        model: {
                          value: _vm.customEmail,
                          callback: function ($$v) {
                            _vm.customEmail = $$v
                          },
                          expression: "customEmail",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("a-button", { on: { click: _vm.cancelDownloadModal } }, [
                  _vm._v(_vm._s(_vm.$t("message.cancelText"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "submit-button",
                    attrs: {
                      type: "primary",
                      disabled: !_vm.isValidEmailSelected,
                    },
                    on: { click: _vm.submitEmailRequest },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.send")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.visible
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "visitor-history-modal",
                visible: _vm.visible,
                title: _vm.$t("message.visitorHistory"),
                description: _vm.$t("message.visitorHistoryDescription"),
                "show-footer": false,
                maskClosable: false,
                width: 1000,
              },
              on: {
                cancel: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [
              _vm.filteredMessages.length
                ? _c("div", { staticClass: "filteredMessages" }, [
                    _c("div", { staticClass: "filteredMessages" }, [
                      _c("div", { staticClass: "parent-div" }, [
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.name") },
                              },
                              [_vm._v("person")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.selectedHistory.visitor.fullname || "-"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.email") },
                              },
                              [_vm._v("mail")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.maskContactInfo(
                                    _vm.selectedHistory.visitor,
                                    "email"
                                  ) || "-"
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "display-flex" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end' }",
                                  },
                                ],
                                staticClass: "icon material-icons",
                                attrs: { content: _vm.$t("coupon.phone") },
                              },
                              [_vm._v("phone")]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.getPhoneNumber()) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        !_vm.visitor.isBlocked
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.ban()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "display-flex" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end' }",
                                        },
                                      ],
                                      staticClass: "icon material-icons",
                                      attrs: {
                                        content: _vm.$t("message.block_"),
                                      },
                                    },
                                    [_vm._v("block")]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("message.block_")) +
                                      "\n                        "
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.unban()
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "display-flex" }, [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{ followCursor: true, placement: 'bottom-end' }",
                                        },
                                      ],
                                      staticClass: "icon material-icons",
                                      attrs: {
                                        content: _vm.$t("message.block_"),
                                      },
                                    },
                                    [_vm._v("block")]
                                  ),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t("message.block_")) +
                                      " Kaldır\n                        "
                                  ),
                                ]),
                              ]
                            ),
                        _vm._v(" "),
                        _c("div", { staticClass: "display-flex" }, [
                          _c(
                            "div",
                            { on: { click: _vm.handleConversationDownload } },
                            [
                              _c(
                                "vue-excel-xlsx",
                                {
                                  staticClass: "download-button",
                                  staticStyle: {
                                    "justify-self": "end",
                                    width: "36px",
                                    "align-self": "center",
                                  },
                                  attrs: {
                                    columns: _vm.downloadConversationFields(),
                                    data: _vm.downloadConversationData(),
                                    fileName: _vm.downloadConversationName,
                                    sheetName: "Page 1",
                                  },
                                },
                                [
                                  _c(
                                    "md-icon",
                                    { staticClass: "material-icons" },
                                    [_vm._v("download")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.download")) +
                              "\n                    "
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.filteredMessages.length
                      ? _c(
                          "div",
                          {
                            directives: [
                              { name: "chat-scroll", rawName: "v-chat-scroll" },
                            ],
                            staticClass: "messages",
                          },
                          [
                            _c("MessageList", {
                              attrs: {
                                "always-scroll-to-bottom": false,
                                colors: _vm.colors,
                                messages: _vm.getMessages(),
                                participants: _vm.getParticipants(),
                                contextMenuVisable: false,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "back-and-forth-button" },
                      [
                        _c(
                          "a-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.navigateHistory(-1)
                              },
                            },
                          },
                          [_vm._v(" < ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.navigateHistory(1)
                              },
                            },
                          },
                          [_vm._v(" > ")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _c(
                    "div",
                    [
                      _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                        _vm._v(_vm._s(_vm.$t("message.chatNotFound"))),
                      ]),
                    ],
                    1
                  ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.visitorHistorySettingsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "tableColumns",
                title: _vm.$t("message.tableSettings"),
                "show-footer": false,
              },
              on: { cancel: _vm.closeVisitorHistorySettingsModal },
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.$t("message.selectColumns")))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tableSettings" },
                [
                  _vm._l(_vm.defaultCols, function (col, i) {
                    return [
                      col.key !== "actions"
                        ? _c("div", { key: col.key }, [
                            _c("div", { staticClass: "item" }, [
                              _c(
                                "div",
                                { staticClass: "checkbox-group" },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: {
                                        disabled:
                                          Object.values(_vm.tableCols).filter(
                                            function (x) {
                                              return x === true
                                            }
                                          ).length > 12 &&
                                          !_vm.tableCols[col.key] &&
                                          _vm.customLoginFormEnabled,
                                      },
                                      on: { input: _vm.toLocalStorage },
                                      model: {
                                        value: _vm.tableCols[col.key],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.tableCols, col.key, $$v)
                                        },
                                        expression: "tableCols[col.key]",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(col.title) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            i % 2 === 1
                              ? _c("div", { staticClass: "clear" })
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }